<template>
    <tr>
        <td>
            <router-link :to="orderDetailsLink">#{{ orderline.ordernumber }}</router-link>
        </td>
        <td class="text-right">{{ orderline.orderdate }}</td>
        <td class="text-right">{{ orderline.orderstatus }}</td>
        <td class="text-right">${{ orderline.ordertotal }}</td>
        <td></td>
        <td>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        orderline: {
            type: Array,
            required: true
        }
    },
    computed: {
        orderDetailsLink() {
            return '/account-orders/' + this.orderline.ordernumber;
        },
    }
}
</script>